export default __webpack_public_path__ + "img/fleche_bas_sombre.e9990539.svg";